var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61642 2.63166C1.78729 2.34875 2.72872 1.31972 3.40053 1.35079C3.60136 1.36743 3.77888 1.48891 3.92312 1.62982C4.25431 1.95323 5.20239 3.17641 5.2562 3.43381C5.38713 4.06509 4.63487 4.42899 4.8651 5.06527C5.45204 6.50147 6.46336 7.51275 7.90019 8.0991C8.53595 8.32932 8.89987 7.5771 9.53119 7.70857C9.78804 7.76238 11.0118 8.71042 11.3353 9.04159C11.4756 9.18527 11.5977 9.36334 11.6143 9.56415C11.6393 10.2714 10.5464 11.2261 10.3334 11.3482C9.83076 11.7076 9.17503 11.7015 8.37562 11.3299C6.14493 10.4018 2.58004 6.90421 1.63473 4.58931C1.27303 3.79438 1.24806 3.13425 1.61642 2.63166Z",
    stroke: "#6C2AD2",
    strokeWidth: 0.81025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.f9c4b2a03c7e9c8a2efe23292c22a1a1.svg";
export { ForwardRef as ReactComponent };